export interface DesktopLayoutProps {
  totalProductItem: number;
}

const DesktopLayout: React.FC<React.PropsWithChildren<DesktopLayoutProps>> = ({ totalProductItem, children }) => {
  return <div className={`hidden grid-cols-1 gap-10 px-20 md:grid grid-cols-${totalProductItem}`}>{children}</div>;
};

export default DesktopLayout;
